

export const colorsTheme = {
    red1: "#f44336",
    green1 : "#4CAF50",
    white1: "#F1F0DE",
    yellow: "rgb(247 222 130)",
    red3: "#E85030",
    blue: "rgb(12 77 162)"
}

export const tiposPokes = [{
    id: 1,
    title: "Volador",
    description: "Defensivamente, el tipo volador se caracteriza por su inmunidad ante los ataques del tipo Tierra y su resistencia a los ataques Lucha. Sin embargo, este tipo también es conocido por tener bajos atributos de defensa, lo que los hace vulnerables a los ataques físicos. En su caracter de atacantes, son útiles frente al tipo Lucha. Dado a su bajo ataque especial, no aprovechan los movimientos basados en este estátus. Como el tipo Volador raramente se presenta como un tipo puro, muchas de sus desventajas se compensan con el segundo tipo del Pokémon.",
    icon: "💨",
},
{
    id:2,
    title: "Veneno",
    description: "Un tipo que se presenta muy útil para utilizarlo con estrategia defensiva, dado a que resisten a los movimientos más habituales como así también a los cambios de estatus. Su gran debilidad, el ataque Terremoto, no es sufrido por algunos de los miembros de este grupo de Pokémon (por ejemplo, los que tengan segundo tipo Volador o bien conozcan la habilidad Levitación). Como tipo atacante, no se presentan muy útiles para hacer KO de un golpe a sus contrincantes, sino que se aprovechan mejor sus movimientos que envenenan, duermen y confunden; para batallas de mas larga duración.",
    icon: "🧪",
},
{
    id:3,
    title: "Fuego",
    description: "Ofensivamente, se caracterizan por ser un tipo muy orientado al ataque, sobre todo en movimientos basados en ataque especial. Se presentan muy útiles contra los Pokémon del tipo Acero y Hielo. Sin embargo, defensivamente hablando son débiles contra los movimientos del tipo Agua, Roca y Tierra. Resultan convenientes como atacantes rápidos y poderosos, pero sus debilidades los pueden dejar rápidamente fuera de combate, por lo que no son recomendables como el mejor tipo para batallas de larga duración.",
    icon: "🔥",
},
{
    id:4,
    title: "Agua",
    description: "El tipo más común del juego. Ofensivamente se presentan como Pokémon muy dúctiles, sobre todo gracias a que muchos de ellos pueden aprender ataques del tipo Hielo (como Rayo Hielo) lo cual permite utilizarlos frente a Pokémon del tipo Dragón y les da fortaleza frente al tipo Planta, su debilidad. Dado a la existencia de varias MO indispensables para avanzar en los juegos, como Surf, Cascada y Buceo, se hace prácticamente obligatorio contar con un Pokémon del tipo Agua en el equipo. Defensivamente es un tipo que que trae satisfacciones cuando nuestro Pokémon de Agua en particular tiene buenos estátus en defensa.",
    icon: "💧",
},
{
    id:5,
    title: "Eléctrico",
    description: "Un tipo lanzado casi totalmente al ataque. Su ataques super efectivos frente al tipo Agua (el más común del juego) y Volador los hace interesantes para incorportarlos al equipo Pokémon, sumado con la capacidad de paralizar enemigos ya sea como estrategia de combate o bien para capturar Pokémon salvajes y Legendarios. Defensivamente se presentan fuertes frente a los ataques especiales y débiles para los físicos, siendo los ataques del tipo Tierra sus peores enemigos.",
    icon: "⚡",
}
];